'use strict';
module.exports = require('./TabView.vue');